
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import get from 'lodash/get';

import mapGetActions from '../../sagas/map';
import infoGetActions from '../../sagas/info';
import ObjectInfoLoading from './ObjectInfoLoading';
import ObjectInfoNotFound from './ObjectInfoNotFound';
import ObjectInfoParcela from './ObjectInfoParcela';
import ObjectInfoParcely from './ObjectInfoParcely';
import ObjectInfoOpsub from './ObjectInfoOpsub';
import ObjectInfoTeleso from './ObjectInfoTeleso';
import ObjectInfoSearchParcela from './ObjectInfoSearchParcela';
import ObjectInfoSearchVlastnik from './ObjectInfoSearchVlastnik';

const classNames = mergeStyleSets({
    root: {
    },
    content: {
        padding: 16,
        paddingTop: 0
    },
    closeButton: {
        width: 16,
        padding: '4px',
        cursor: 'pointer',
        color: '#aaaaaa',
        selectors: {
            ':hover': {
                color: '#000000'
            }
        }
    },
    closeButtonIcon: {
        fontSize: 8,
        height: 8,
        width: 8,
        margin: '0 0 0 0'
    }
});

const ObjectInfoContent = (props) => {

    const dispatch = useDispatch();
    const mapActions = mapGetActions(dispatch);

    const info = useSelector(state => {
        return state.info;
    });

    useEffect(() => {
        let geoJsons = null;
        let geoJson = get(info, 'data.result.params.geom');
        if (!geoJson) {
            geoJsons = [];
        }
        mapActions.addCommand(
            'HIGHLIGHT_FEATURE',
            {
                geoJson: geoJson,
                geoJsons: geoJsons,
                zoomToFeature: false
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [info]);

    if (info.loading) {
        return <ObjectInfoLoading />;
    }

    if (info.data && info.data.result) {
        switch (info.data.result.type) {
            case 'NOT_FOUND':
                return <ObjectInfoNotFound />;
            case 'PARCELA':
                return <ObjectInfoParcela info={info.data.result} />;
            case 'PARCELY':
                return <ObjectInfoParcely parc={info.data.result.par} title="PARCELY" />;
            case 'OPSUB':
                return <ObjectInfoOpsub info={info.data.result} />;
            case 'TELESO':
                return <ObjectInfoTeleso info={info.data.result} />;
            case 'SEARCH_PAR':
                return <ObjectInfoSearchParcela info={info.data.result} />;
            case 'SEARCH_VLA':
                return <ObjectInfoSearchVlastnik info={info.data.result} />;
            default:
                return null;
        }
    }

    return null;
}

const ObjectInfo = (props) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);
    const mapActions = mapGetActions(dispatch);

    const infoVisible = useSelector(state => {
        return state.info.visible;
    });

    useEffect(() => {
        if (!infoVisible) {
            mapActions.addCommand(
                'HIGHLIGHT_FEATURE',
                {
                    geoJsons: [],
                    zoomToFeature: false
                }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [infoVisible]);

    const onClick = () => {
        infoActions.close();
    }

    return (infoVisible &&
        <div className={classNames.root}>
            <Stack horizontalAlign="end">
                <div className={classNames.closeButton} onClick={onClick}>
                    <FontIcon
                        iconName="Cancel"
                        className={classNames.closeButtonIcon}
                        title="Zavřít"
                    />
                </div>
            </Stack>
            <div className={classNames.content}>
                <ObjectInfoContent />
            </div>
        </div>
    );
}

export default ObjectInfo;
